import { render, staticRenderFns } from "./daigong.vue?vue&type=template&id=4b1f48a9&scoped=true&"
import script from "./daigong.vue?vue&type=script&lang=js&"
export * from "./daigong.vue?vue&type=script&lang=js&"
import style0 from "./daigong.vue?vue&type=style&index=0&id=4b1f48a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f48a9",
  null
  
)

export default component.exports